const locale = {
	DETAILS_PHONES_FIELD_TITLE: 'Numero di telefono',
	DETAILS_PHONES_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_PHONES_FIELD_TITLE_INDEX: 'Numero di telefono {index}',
	DETAILS_PHONES_FIELD_DESCRIPTION_INDEX: 'Descrizione {index}',
	DETAILS_PHONES_FIELD_DEFAULT: 'Default',

	DIALOG_PHONES_ADD: 'Aggiungi Numero di Telefono',

	PHONES_ERRORS_COLUMN_COMPANY: 'Azienda',
	PHONES_ERRORS_COLUMN_COUNTRY: 'Nazione',
	PHONES_ERRORS_COLUMN_ERROR: 'Errore',

	PHONES_ERRORS_UNEXPECTED_CHARACTER: 'Carattere imprevisto',
	PHONES_ERRORS_INCORRECT_INTERNATIONAL_PREFIX: 'Prefisso internazionale non corretto ({country})',
	PHONES_ERRORS_MISSING_INTERNATIONAL_PREFIX: 'Prefisso internazionale mancante ({country})',

	// #region Tabs
	TAB_LIST: 'Lista',
	TAB_ERRORS: 'Controllo errori'
	// #endregion
};

export default locale;
